import React, { ForwardedRef, forwardRef } from 'react';
import { ModalContentStyled } from './ModalContent.style';

interface ModalContentProps {
    width?: number | string;
    height?: number | string;
    maxHeight?: number | string;
    padding?: number;
}

function ModalContentInner(props: React.PropsWithChildren<ModalContentProps>, ref: ForwardedRef<HTMLDivElement>) {
    const { width = 300, height, maxHeight = '95vh', padding, children } = props;
    return (
        <ModalContentStyled ref={ref} padding={padding} style={{ width, height, maxHeight }}>
            {children}
        </ModalContentStyled>
    );
}

export const ModalContent = forwardRef(ModalContentInner);
ModalContent.displayName = 'ModalContent';
